define('PartLookupSearcher.Utils', [
  'Configuration',
  'Utils',
  'underscore',
], function (
  Configuration,
  Utils,
  _,
) {
	'use strict';

	return {
		formatKeywords: function (keywords) {
			var keywordFormatter = Utils.getPathFromObject( Configuration, 'searchPrefs.keywordsFormatter' );

			if (keywordFormatter && _.isFunction(keywordFormatter)) {
				keywords = keywordFormatter(keywords);
				var maxLength = Utils.getPathFromObject( Configuration, 'searchPrefs.maxLength', 99999 );
				if (keywords.length > maxLength) {
					keywords = keywords.substring(0, maxLength);
				}
			}

			return keywords;
		},
	};
});
